import styles from '../../../MultiStepPMSLogin.module.scss'

const LoginURL = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        Each hotel have their own unique Opera Cloud URL.
      </p>
      <p className={styles.descriptionTextEmp}>
        The unique Opera Cloud URL of the hotel should be looking like this:
      </p>
      <p
        className={styles.descriptionText}
        style={{ color: 'blue', textDecoration: 'underline' }}
      >
        https://mtucu2.oraclehospitality.us-ashburn-1.ocs.oraclecloud.com/OPERA9/opera/operacloud/faces/opera-cloud-index/OperaCloud
      </p>
    </div>
  )
}

export default LoginURL
